import React, { useState, useEffect, useCallback } from "react";

import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLoading, setModule } from "../../store/actions/commonAction";
import CommonDataService from "../../services/common";
import { parseNumber } from "../../helpers/common";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Divider from "@mui/material/Divider";
import SaveIcon from "@mui/icons-material/Save";

import MessageDialog from "../MessageDialog";
import http from "../../http";

export default function AddDeveloper({ placeholder }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let { id } = useParams();

	const loading = useSelector((state) => state.commonReducer.loading);

	const [message, setMessage] = useState("");
	const [error, setError] = useState(false);

	const [name, setName] = useState("");
	const [address, setAddress] = useState("");
	const [whatsapp, setWhatsapp] = useState("");
	const [uniqueName, setUniqueName] = useState("");

	const LoadSelect = useCallback(() => {
		dispatch(setLoading(true));
		dispatch(setModule("Developer"));

		if (typeof id !== "undefined") {
			CommonDataService.getDeveloperById(id).then((res) => {
				setName(res.data.Row.name);
				setAddress(res.data.Row.address);
				setWhatsapp(res.data.Row.whatsapp);
				setUniqueName(res.data.Row.unique_name);

				dispatch(setLoading(false));
			});
		} else {
			dispatch(setLoading(false));
		}
	}, [dispatch, id]);

	useEffect(() => {
		LoadSelect();
	}, [LoadSelect]);

	const handleSubmit = (event) => {
		event.preventDefault();

		if (typeof id === "undefined") {
			id = 0;
		}

		dispatch(setLoading(true));

		const data = {
			id: parseNumber(id),
			address: address,
			whatsapp: whatsapp,
			unique_name: uniqueName,
		};

		http
			.post("/developer/save", data)
			.then((res) => {
				dispatch(setLoading(false));
				navigate("/developer" + window.location.search);
			})
			.catch(function (error) {
				setMessage(error.response.data.message);
				setError(true);
				dispatch(setLoading(false));
			});
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<MessageDialog show={error} message={message} dialogClose={setError} />

				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box component="form" onSubmit={(e) => handleSubmit(e)}>
						<Typography variant="h5">Developer Form</Typography>

						<Grid container spacing={3}>
							<Grid item xs={12} sm={12}>
								<Typography variant="h6" gutterBottom>
									{name}
								</Typography>
							</Grid>

							<Grid item xs={12} sm={6}>
								<TextField
									required
									label="Unique Name"
									id="uniqueName"
									name="uniqueName"
									value={uniqueName}
									fullWidth
									variant="standard"
									onChange={(e) => setUniqueName(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<TextField
									required
									label="Whatsapp"
									id="whatsapp"
									name="whatsapp"
									value={whatsapp}
									fullWidth
									variant="standard"
									onChange={(e) => setWhatsapp(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<TextField
									label="Address"
									id="address"
									name="address"
									value={address}
									fullWidth
									multiline
									rows={4}
									onChange={(e) => setAddress(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<Divider />
							</Grid>

							<Grid item xs={12} sm={12}>
								<Button
									variant="contained"
									component={Link}
									to={"/developer" + window.location.search}
									startIcon={<ArrowBackIcon />}
									sx={{ mr: 1 }}
								>
									Cancel
								</Button>
								<Button
									type="submit"
									variant="contained"
									disabled={loading}
									startIcon={<SaveIcon />}
								>
									{loading && (
										<span>
											<span className="spinner-border spinner-border-sm"></span>
											&nbsp;
										</span>
									)}
									<span> {loading ? "Please Wait" : "Save"}</span>
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	);
}
